export class ManifestIntegrationItemModel {
    id;
    title;
    recommendedFor;
    logo;
    dataLink;
    productTags;
    filterTags;
    description;
    osTags;
    bundle;
}
export class BundleModel {
    type;
    id;
}
//# sourceMappingURL=manifest-item.js.map